export const CODE_SUCCESS_0000 = '0000' //成功

export const CODE_UNLOGIN = 103 //未登录

export const CODE_0003 = '0003' //活动未开始
